export default __webpack_public_path__ + "static/media/dotMarker.35546cf9.svg";